import { BID_REQUEST_STATUS_ENUM, BidRequestStatus } from "interfaces";
import { DOCUMENTS_COLLAPSE_THRESHOLD } from "./envConstants";
import { isStatusLaterOrEqualThan } from "utils";

/**
 * Подсчитывает общее количество документов
 */
export const getTotalDocumentsCount = (
  documents: Record<string, any[]>,
  additionalDocuments: Record<string, any[]> = {},
  reports: any[] = []
): number => {
  let count = 0;

  Object.values(documents).forEach((docArray) => {
    if (Array.isArray(docArray)) {
      count += docArray.length;
    }
  });

  Object.values(additionalDocuments).forEach((docArray) => {
    if (Array.isArray(docArray)) {
      count += docArray.length;
    }
  });

  count += Array.isArray(reports) ? reports.filter((report) => report !== null).length : 0;

  return count;
};

/**
 * Определяет, нужно ли сворачивать блок документов
 */
export const shouldCollapseDocuments = (status: BidRequestStatus, documentsCount: number): boolean => {
  const statusesForCollapse = isStatusLaterOrEqualThan(status, BID_REQUEST_STATUS_ENUM, BID_REQUEST_STATUS_ENUM.NEW);

  return statusesForCollapse && documentsCount > DOCUMENTS_COLLAPSE_THRESHOLD;
};
